import { UpdateStudentData } from "../../student/models/student-data.model";

export class FamilyData {
  familyId: number;
  familyName: string;
  firstName: string;
  lastName: string;
  iban: string;
  bank: string;
  branch: string;
  controlDigit: string;
  bankAccount: string;
  customerKey: string;
  oracleNumber: number;
  identification: string;
  customerName: string;
  isAmpa: boolean;
  schoolName: string;
  schoolId: number;
  address: string;
  city: string;
  province: string;
  email: string;
  zipCode: string;
  sendInvoiceByEmail: boolean;
  phone: string;
  mobilePhone: string;
  debt: number;
  debtStateId: number;
  debtYearId: number;
  languageId: number;
  familyDocumentType: number;
  accountingAccount: string;
  profitCenterCode: string;
  isActive: boolean;
  schoolNumber: number;
  zoneId: number;
}

export class UpdateFamilyData {
  familyId: number;
  familyName: string;
  firstName: string;
  lastName: string;
  iban: string;
  bank: string;
  branch: string;
  controlDigit: string;
  internalBankAccountNumber: string;
  accountingAccount: string;
  customerKey: string;
  identification: string;
  isAmpa: boolean;
  address: string;
  city: string;
  province: string;
  email: string;
  zipCode: string;
  sendInvoiceByEmail: boolean;
  phone: string;
  mobilePhone: string;
  debt: number;
  debtStateId: number;
  debtYearId: number;
  familyDocumentType: number;
  languageId: number;
  exerciseId: number;
  schoolId: number;
  profitCenterCode: string;
  isActive: boolean;
  schoolNumber: number;
  dirty: boolean;
  students: UpdateStudentData[];
}